import * as Yup from "yup";


export const formSchema = Yup.object().shape({
  startsAt: Yup.mixed().required("Start Date is required"),
  endsAt: Yup.mixed().required("End Date is required"),
  status: Yup.string(),
});